<template>
  <div :class="'progress '+( (barType=='normal')? ' progress-normal' : '') ">
    <div
      :class="'progress-bar '+( (barType=='normal')? ' progress-bar-normal ' : '' )+ getClasses(color, variant)"
      :style="{ width: percentage + '%' }"
    ></div>
  </div>
</template>

<script>
export default {
  name: "VsudProgress",
  props: {
    color: {
      type: String,
      default: "success",
    },
    variant: {
      type: String,
      default: "fill",
    },
    percentage: {
      type: Number,
      required: true,
    },
    barType : {
      type : String,
      default : 'normal'
    }
  },
  methods: {
    getClasses: (color, variant) => {
      let colorValue;

      if (variant === "gradient") {
        colorValue = `bg-gradient-${color}`;
      } else {
        colorValue = `bg-${color}`;
      }

      return `${colorValue}`;
    }
  },
};
</script>
